import { render, staticRenderFns } from "./ShippingList.vue?vue&type=template&id=4d66d796"
import script from "./ShippingList.vue?vue&type=script&lang=js"
export * from "./ShippingList.vue?vue&type=script&lang=js"
import style0 from "./ShippingList.vue?vue&type=style&index=0&id=4d66d796&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports